<template>
  <div style="height: 100%">
    <CustomPageHeaderVue>{{ $t("news_list_title") }}</CustomPageHeaderVue>
    <CustomRow style="height: calc(100% - 100px)">
      <v-card class="pa-5 my-5 cus-card-height" v-if="loadingFinished">
        <template v-for="(news, i) in newsList">
          <div
            :key="`news-${i}`"
            @click="
              $router.push({ name: 'News', params: { id: news.news_id } })
            "
            class="cursor-pointer"
          >
            <div class="mt-3 mx-2 text-title">
              <v-icon color="grey darken-1" dense>mdi-message-alert</v-icon
              ><span>{{ news.title }}</span>
            </div>
            <div class="grey--text text--darken-1 ma-2 text-small">
              {{ news.time }}
            </div>
            <div
              class="red-dash-divider"
              v-if="i !== newsList.length - 1"
            ></div>
          </div>
        </template>
      </v-card>
      <v-card v-else class="text-center">
        <ProgressCircular />
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import { getNews } from "@/api/static";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";

export default {
  components: { CustomPageHeaderVue },
  data() {
    return {
      page: 1,
      frontNewsList: [],
      newsList: [],
      sortedNewsList: [],
      loadingFinished: false,
    };
  },
  metaInfo() {
    return {
      title: `${this.$t("news_list_title")} - ${this.$t("app_name")}`,
      meta: [
        {
          property: "og:title",
          content: `${this.$t("news_list_title")} - ${this.$t("app_name")}`,
          vmid: "og:title",
        },
        {
          property: "og:url",
          content: window.location.origin + window.location.pathname,
          vmid: "og:url",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.$t("news_list_title")} - ${this.$t("app_name")}`,
            url: window.location.origin + window.location.pathname,
          },
        },
      ],
    };
  },
  mounted() {
    getNews().then((res) => {
      this.sortedNewsList = res.data.sortedNewsList;
      // this.newsList = res.data.news;
      let frontNewsList = this.sortedNewsList.map((n) => {
        let news = res.data.news.find((ne) => ne.news_id === n);
        return news;
      });

      let afterNews = res.data.news.filter(
        (n) => this.sortedNewsList.indexOf(n.news_id) === -1
      );
      afterNews.sort((a, b) => {
        let aTime = new Date(a.time);
        let bTime = new Date(b.time);
        return aTime.valueOf() - bTime.valueOf();
      });

      let newsList = [...frontNewsList, ...afterNews];

      this.newsList = newsList.reduce((accr, news, index) => {
        let dt = new Date();
        let start = new Date(news.exposeStart);
        let end = new Date(news.exposeEnd);
        if (
          news.exposeStart &&
          news.exposeEnd &&
          start.valueOf() <= dt.valueOf() &&
          end.valueOf() >= dt.valueOf()
        ) {
          accr.push(news);
        }
        return accr;
      }, []);

      this.loadingFinished = true;
      this.$store.dispatch("setOverlayLoading", false);
      this.$gtm.trackView("活動公告", this.$route.path);
    });
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: $radiusDesktop;

  @media screen and (max-width: 768px) {
    border-radius: $radiusMobile;
  }
}

.cus-card-height {
  min-height: 100%;
}

::v-deep .v-pagination__item--active {
  color: $primary-1 !important;
}
</style>
